import PolicyDocumentPage from './PolicyDocumentPage'

const FALLBACK = `
<p>DigiSutra provides digital marketing and consulting services. All fees paid for our services are non-refundable. We do not offer returns or refunds once payment has been made.</p>
<h2>Payment &amp; No Refunds</h2>
<p>Once payment has been made, we do not process refunds under any circumstances. By engaging our services and making payment, you agree to this policy.</p>
<h2>Contact</h2>
<p>For any queries regarding this policy: info@digisutra.in.</p>
`

export default function RefundPage() {
  return <PolicyDocumentPage slug="refund" fallbackTitle="Refund Policy" fallbackHtml={FALLBACK} />
}
